// BlurText.js — Título que entra palavra por palavra, saindo de um leve blur.
// Papel do `BlurText` do react-bits, em CSS.
//
// Reservado ao título do hero: é a primeira coisa que a pessoa lê e o efeito
// dura menos de meio segundo. Em qualquer outro lugar do site seria ruído.
//
// Segue a mesma regra do Reveal: passada a entrada, as classes de animação
// saem e o título fica visível por estilo normal. Um título de hero é caro
// demais para depender de a animação ter rodado (ver useRevelar.js).
import React, { useEffect, useState } from "react";
import { useReducedMotion } from "motion/react";
import { classesDoEstado } from "./useRevelar";

const BlurText = ({ texto = "", as: Tag = "h1", className = "", delay = 0 }) => {
  const reduzirMovimento = useReducedMotion();
  const [estado, setEstado] = useState("oculto");

  // O hero está sempre no topo da página: não há o que observar, basta deixar
  // o primeiro quadro pintar antes de trocar a classe (senão o navegador
  // aplicaria os dois estados de uma vez e não haveria transição).
  useEffect(() => {
    const t1 = setTimeout(() => setEstado("revelando"), 60);
    // Igual ao useRevelar: depois da entrada as classes de animação saem, para
    // o título nunca depender do relógio de animação para existir na tela.
    const t2 = setTimeout(() => setEstado("pronto"), 1400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (reduzirMovimento || !texto) {
    return <Tag className={className}>{texto}</Tag>;
  }

  const palavras = texto.split(" ");

  return (
    <Tag className={className} aria-label={texto}>
      {palavras.map((palavra, i) => (
        <span
          key={i}
          aria-hidden="true"
          // `whitespace-pre` preserva o espaço final: dentro de um inline-block
          // o navegador o descartaria e as palavras ficariam grudadas.
          className={
            "inline-block whitespace-pre " + classesDoEstado(estado, "revelar-borrado")
          }
          style={{ "--revelar-y": "14px", transitionDelay: `${delay + i * 0.055}s` }}
        >
          {palavra}
          {i < palavras.length - 1 ? " " : ""}
        </span>
      ))}
    </Tag>
  );
};

export default BlurText;
